import { useMutation } from "@tanstack/react-query";
import { closeActivity, CloseActivityPayload } from "PFCore/services/activities";
import { Activity, MutationOptions } from "PFTypes";

export const useActivityClose = (options: MutationOptions<CloseActivityPayload> = {}) =>
  useMutation<Activity, unknown, CloseActivityPayload>({
    mutationFn: (payload: CloseActivityPayload) => closeActivity(payload),
    ...options,
    onSuccess: (...args) => {
      options.onSuccess?.(...args);
    }
  });
